import { render } from "./canceledReservations.vue?vue&type=template&id=70720860"
import script from "./canceledReservations.vue?vue&type=script&lang=js"
export * from "./canceledReservations.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__